// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__bfiKF","label":"Labeled_label__1Sti_","divider":"Labeled_divider__1rQzX"};